import { Selector } from "react-redux";
import { createSelector } from "reselect";

import { getDataSourceInstance } from "@multiweb/reactCore/datasource";
import { IAppState, RootNodeTypedObject } from "@multiweb/types/react";

/**
 * Vrátí pole rootNodes
 * @param state
 * @param dataSourceKey Klíč k instanci DataSource.
 */
export const getRootNodes: Selector<IAppState, RootNodeTypedObject | undefined, string> = (
    state,
    dataSourceKey,
) => getDataSourceInstance(state, dataSourceKey)?.multiselect.rootNodes;

/**
 * Projde RootNodes a získá celkový počet dětí.
 *
 * @param state
 * @param dataSourceKey Klíč k instanci DataSource.
 * @returns Celkový počet dětí v RootNodes.
 */
export const createGetRootNodesChildrenCount = () =>
    createSelector<IAppState, string, ReturnType<typeof getRootNodes>, number | undefined>(
        (state, dataSourceKey) => getRootNodes(state, dataSourceKey),
        (rootNodes) => {
            if (!rootNodes) {
                return undefined;
            }

            const rootNodesArr = Object.values(rootNodes);

            return rootNodesArr.reduce((accumulator, currentVal) => {
                return accumulator += currentVal?.children?.length ?? 0;
            }, 0);
        },
    );
